// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Shell ──────────────────────────────────────────────────── */
.cop-shell {
  background: #f5f6fa;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

.cop-shell.dark {
  background: var(--dark-blue);
}

/* ── Header ─────────────────────────────────────────────────── */
.cop-header {
  padding: 16px 14px 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cop-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cop-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.cop-count-badge {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  background: #e5e7eb;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ── Search ─────────────────────────────────────────────────── */
.cop-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.cop-search-icon {
  position: absolute;
  left: 12px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.cop-search-input {
  width: 100%;
  border: 1.5px solid #e5e7eb;
  border-radius: 999px;
  padding: 8px 14px 8px 34px;
  font-size: 13px;
  color: #374151;
  background: #fff;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.cop-search-input:focus {
  border-color: #93c5fd;
}

.cop-search-input::placeholder {
  color: #9ca3af;
}

/* ── Drag/Reset row ─────────────────────────────────────────── */
.cop-drag-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cop-drag-text {
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.4;
  max-width: 110px;
}

.cop-reset-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  padding: 2px 6px;
  border-radius: 6px;
}

.cop-search-input::placeholder {
  color: #9ca3af;
}

/* ── Drag/Reset row ─────────────────────────────────────────── */
.cop-drag-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cop-drag-text {
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.4;
  max-width: 110px;
}

.cop-reset-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  padding: 2px 6px;
  border-radius: 6px;
  transition:
    background 0.12s,
    color 0.12s;
}

.cop-reset-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

/* ── Scrollable list ────────────────────────────────────────── */
.cop-list-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 4px 10px 12px;
}

.cop-list-scroll::-webkit-scrollbar {
  width: 3px;
}
.cop-list-scroll::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}
.cop-list-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.cop-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cop-empty {
  font-size: 13px;
  color: #9ca3af;
  padding: 20px 0;
  text-align: center;
}

/* ── Favorites card ─────────────────────────────────────────── */
.cop-fav-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1.5px solid #fed7aa;
  border-radius: 12px;
  padding: 12px 12px;
  cursor: pointer;
  margin-bottom: 6px;
  transition:
    box-shadow 0.15s,
    border-color 0.15s;
}

.cop-fav-card:hover {
  box-shadow: 0 2px 8px rgba(251, 146, 60, 0.15);
  border-color: #fb923c;
}

.cop-fav-card.active {
  border-color: #f97316;
  background: #fff7ed;
}

.cop-fav-star {
  color: #f97316;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.cop-fav-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.cop-fav-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.cop-fav-sub {
  font-size: 11px;
  font-weight: 500;
  color: #f97316;
}

.cop-fav-count {
  font-size: 13px;
  font-weight: 700;
  color: #f97316;
  background: #ffedd5;
  border-radius: 8px;
  padding: 2px 8px;
  flex-shrink: 0;
}

/* ── Regular category item ──────────────────────────────────── */
.cop-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition:
    background 0.12s,
    box-shadow 0.12s;
  background: transparent;
}

.cop-item:hover:not(.active) {
  background: #fff;
}

.cop-item.active {
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
}

.cop-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #314158;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cop-item-name.active {
  font-weight: 700;
  color: #2463eb;
}

.cop-item-count {
  font-size: 13px;
  font-weight: 600;
  color: #9ca3af;
  flex-shrink: 0;
}

.cop-item-count.active {
  color: #374151;
}

/* ── Search highlight ───────────────────────────────────────── */
.cop-highlight {
  font-weight: 700;
  color: #2563eb;
}

/* ════════════════════════════════════════════════════
   DARK THEME — CategoryOptionsPage
   ════════════════════════════════════════════════════ */
.dark .cop-shell {
  background: #0f172a;
}
.dark .cop-title {
  color: #f1f5f9;
}
.dark .cop-count-badge {
  background: #334155;
  color: #94a3b8;
}
.dark .cop-search-input {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .cop-search-input:focus {
  border-color: #3b82f6;
}
.dark .cop-search-input::placeholder {
  color: #64748b;
}
.dark .cop-drag-text {
  color: #64748b;
}
.dark .cop-reset-btn {
  color: #94a3b8;
}
.dark .cop-reset-btn:hover {
  background: #334155;
  color: #e2e8f0;
}
.dark .cop-empty {
  color: #64748b;
}
/* Category items */
.dark .cop-item:hover:not(.active) {
  background: #1e293b;
}
.dark .cop-item.active {
  background: #1e293b;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}
.dark .cop-item-name {
  color: #cbd5e1;
}
.dark .cop-item-name.active {
  color: #60a5fa;
}
.dark .cop-item-count {
  color: #64748b;
}
.dark .cop-item-count.active {
  color: #94a3b8;
}
/* Favourites card */
.dark .cop-fav-card {
  background: #1e293b;
  border-color: #4b3a20;
}
.dark .cop-fav-card:hover {
  border-color: #b45309;
  box-shadow: 0 2px 8px rgba(180, 83, 9, 0.2);
}
.dark .cop-fav-card.active {
  background: #2a1f0e;
  border-color: #d97706;
}
.dark .cop-fav-title {
  color: #f1f5f9;
}
.dark .cop-fav-count {
  background: rgba(217, 119, 6, 0.2);
}
/* replitPanel variant in dark */
.dark .cop-shell.cop-replitPanel {
  background: #0f172a;
}
.dark .cop-replitPanel .cop-header {
  border-bottom-color: #1e293b;
}
.dark .cop-replitPanel .cop-item {
  color: #94a3b8;
}
.dark .cop-replitPanel .cop-item:hover:not(.active) {
  background: rgba(30, 41, 59, 0.6);
}
.dark .cop-replitPanel .cop-item:hover:not(.active) .cop-item-name {
  color: #e2e8f0;
}
.dark .cop-replitPanel .cop-item.active {
  background: #1e293b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
.dark .cop-replitPanel .cop-item-name {
  color: #94a3b8;
}
.dark .cop-replitPanel .cop-item-name.active {
  color: #60a5fa;
}
.dark .cop-replitPanel .cop-item-count,
.dark .cop-replitPanel .cop-fav-count {
  background: #1e293b;
  color: #64748b;
}
.dark .cop-replitPanel .cop-fav-card {
  background: rgba(30, 41, 59, 0.9);
  border-color: #3d2f1a;
}
.dark .cop-replitPanel .cop-fav-card:hover {
  border-color: #78350f;
  background: rgba(41, 29, 10, 0.6);
}
.dark .cop-replitPanel .cop-fav-card.active {
  background: #1e293b;
}
.dark .cop-replitPanel .cop-fav-title {
  color: #e2e8f0;
}

/* POS category panel variant, matched to the Replit sidebar treatment */
.cop-shell.cop-replitPanel {
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #fbfcff 26%,
      #f9f7fd 58%,
      #f7f2fb 100%
    );
}

.cop-replitPanel .cop-header {
  padding: 16px 14px 12px;
  border-bottom: 1px solid #eceef4;
  background: transparent;
}

.cop-replitPanel .cop-list-scroll {
  padding: 16px 16px 18px;
}

.cop-replitPanel .cop-list {
  gap: 8px;
}

.cop-replitPanel .cop-item {
  min-height: 48px;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 16px;
  background: transparent;
  color: #64748b;
}

.cop-replitPanel .cop-item:hover:not(.active) {
  background: rgba(255, 255, 255, 0.6);
}

.cop-replitPanel .cop-item:hover:not(.active) .cop-item-name {
  color: #0f172a;
}

.cop-replitPanel .cop-item.active {
  background: #ffffff;
  border-color: transparent;
  box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.05),
    0 0 0 1px rgba(0, 0, 0, 0.05);
}

.cop-replitPanel .cop-item.combos {
  background: rgba(255, 255, 255, 0.9);
  border-color: #ede9fe;
  color: #334155;
}

.cop-replitPanel .cop-item.combos:hover:not(.active) {
  border-color: #ddd6fe;
  background: rgba(245, 243, 255, 0.6);
}

.cop-replitPanel .cop-item-name {
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

.cop-replitPanel .cop-item-name.active {
  color: #0860e6;
  font-weight: 600;
}

.cop-replitPanel .cop-item-count,
.cop-replitPanel .cop-fav-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 24px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.cop-replitPanel .cop-item-count.active {
  color: #64748b;
}

.cop-replitPanel .cop-item.combos .cop-item-count {
  color: #7c3aed;
}

.cop-replitPanel .cop-fav-card {
  min-height: 58px;
  margin-bottom: 0;
  padding: 12px;
  border: 1px solid #fef3c7;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: none;
}

.cop-replitPanel .cop-fav-card:hover {
  border-color: #fde68a;
  background: rgba(255, 251, 235, 0.6);
  box-shadow: none;
}

.cop-replitPanel .cop-fav-card.active {
  background: #ffffff;
  border-color: transparent;
  box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.05),
    0 0 0 1px rgba(0, 0, 0, 0.05);
}

.cop-replitPanel .cop-fav-title {
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}

.cop-replitPanel .cop-fav-sub {
  color: #d97706;
  font-size: 11px;
  font-weight: 500;
}

.cop-replitPanel .cop-fav-count {
  color: #d97706;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CategoryOptionsPage.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kEAAkE;AAClE;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;;eAEa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,OAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB;;sBAEoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf;;oBAEkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;yDAEyD;AACzD;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;AACA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE;;;;;;;KAOG;AACL;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;;iCAE+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;;iCAE+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ── Shell ──────────────────────────────────────────────────── */\n.cop-shell {\n  background: #f5f6fa;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: hidden;\n}\n\n.cop-shell.dark {\n  background: var(--dark-blue);\n}\n\n/* ── Header ─────────────────────────────────────────────────── */\n.cop-header {\n  padding: 16px 14px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cop-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cop-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.cop-count-badge {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  background: #e5e7eb;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ── Search ─────────────────────────────────────────────────── */\n.cop-search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.cop-search-icon {\n  position: absolute;\n  left: 12px;\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.cop-search-input {\n  width: 100%;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 999px;\n  padding: 8px 14px 8px 34px;\n  font-size: 13px;\n  color: #374151;\n  background: #fff;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n\n.cop-search-input:focus {\n  border-color: #93c5fd;\n}\n\n.cop-search-input::placeholder {\n  color: #9ca3af;\n}\n\n/* ── Drag/Reset row ─────────────────────────────────────────── */\n.cop-drag-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cop-drag-text {\n  font-size: 11px;\n  color: #9ca3af;\n  line-height: 1.4;\n  max-width: 110px;\n}\n\n.cop-reset-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  padding: 2px 6px;\n  border-radius: 6px;\n}\n\n.cop-search-input::placeholder {\n  color: #9ca3af;\n}\n\n/* ── Drag/Reset row ─────────────────────────────────────────── */\n.cop-drag-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cop-drag-text {\n  font-size: 11px;\n  color: #9ca3af;\n  line-height: 1.4;\n  max-width: 110px;\n}\n\n.cop-reset-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  padding: 2px 6px;\n  border-radius: 6px;\n  transition:\n    background 0.12s,\n    color 0.12s;\n}\n\n.cop-reset-btn:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n/* ── Scrollable list ────────────────────────────────────────── */\n.cop-list-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 10px 12px;\n}\n\n.cop-list-scroll::-webkit-scrollbar {\n  width: 3px;\n}\n.cop-list-scroll::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 4px;\n}\n.cop-list-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.cop-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.cop-empty {\n  font-size: 13px;\n  color: #9ca3af;\n  padding: 20px 0;\n  text-align: center;\n}\n\n/* ── Favorites card ─────────────────────────────────────────── */\n.cop-fav-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  border: 1.5px solid #fed7aa;\n  border-radius: 12px;\n  padding: 12px 12px;\n  cursor: pointer;\n  margin-bottom: 6px;\n  transition:\n    box-shadow 0.15s,\n    border-color 0.15s;\n}\n\n.cop-fav-card:hover {\n  box-shadow: 0 2px 8px rgba(251, 146, 60, 0.15);\n  border-color: #fb923c;\n}\n\n.cop-fav-card.active {\n  border-color: #f97316;\n  background: #fff7ed;\n}\n\n.cop-fav-star {\n  color: #f97316;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.cop-fav-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.cop-fav-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.cop-fav-sub {\n  font-size: 11px;\n  font-weight: 500;\n  color: #f97316;\n}\n\n.cop-fav-count {\n  font-size: 13px;\n  font-weight: 700;\n  color: #f97316;\n  background: #ffedd5;\n  border-radius: 8px;\n  padding: 2px 8px;\n  flex-shrink: 0;\n}\n\n/* ── Regular category item ──────────────────────────────────── */\n.cop-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 12px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition:\n    background 0.12s,\n    box-shadow 0.12s;\n  background: transparent;\n}\n\n.cop-item:hover:not(.active) {\n  background: #fff;\n}\n\n.cop-item.active {\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);\n}\n\n.cop-item-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #314158;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cop-item-name.active {\n  font-weight: 700;\n  color: #2463eb;\n}\n\n.cop-item-count {\n  font-size: 13px;\n  font-weight: 600;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.cop-item-count.active {\n  color: #374151;\n}\n\n/* ── Search highlight ───────────────────────────────────────── */\n.cop-highlight {\n  font-weight: 700;\n  color: #2563eb;\n}\n\n/* ════════════════════════════════════════════════════\n   DARK THEME — CategoryOptionsPage\n   ════════════════════════════════════════════════════ */\n.dark .cop-shell {\n  background: #0f172a;\n}\n.dark .cop-title {\n  color: #f1f5f9;\n}\n.dark .cop-count-badge {\n  background: #334155;\n  color: #94a3b8;\n}\n.dark .cop-search-input {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .cop-search-input:focus {\n  border-color: #3b82f6;\n}\n.dark .cop-search-input::placeholder {\n  color: #64748b;\n}\n.dark .cop-drag-text {\n  color: #64748b;\n}\n.dark .cop-reset-btn {\n  color: #94a3b8;\n}\n.dark .cop-reset-btn:hover {\n  background: #334155;\n  color: #e2e8f0;\n}\n.dark .cop-empty {\n  color: #64748b;\n}\n/* Category items */\n.dark .cop-item:hover:not(.active) {\n  background: #1e293b;\n}\n.dark .cop-item.active {\n  background: #1e293b;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);\n}\n.dark .cop-item-name {\n  color: #cbd5e1;\n}\n.dark .cop-item-name.active {\n  color: #60a5fa;\n}\n.dark .cop-item-count {\n  color: #64748b;\n}\n.dark .cop-item-count.active {\n  color: #94a3b8;\n}\n/* Favourites card */\n.dark .cop-fav-card {\n  background: #1e293b;\n  border-color: #4b3a20;\n}\n.dark .cop-fav-card:hover {\n  border-color: #b45309;\n  box-shadow: 0 2px 8px rgba(180, 83, 9, 0.2);\n}\n.dark .cop-fav-card.active {\n  background: #2a1f0e;\n  border-color: #d97706;\n}\n.dark .cop-fav-title {\n  color: #f1f5f9;\n}\n.dark .cop-fav-count {\n  background: rgba(217, 119, 6, 0.2);\n}\n/* replitPanel variant in dark */\n.dark .cop-shell.cop-replitPanel {\n  background: #0f172a;\n}\n.dark .cop-replitPanel .cop-header {\n  border-bottom-color: #1e293b;\n}\n.dark .cop-replitPanel .cop-item {\n  color: #94a3b8;\n}\n.dark .cop-replitPanel .cop-item:hover:not(.active) {\n  background: rgba(30, 41, 59, 0.6);\n}\n.dark .cop-replitPanel .cop-item:hover:not(.active) .cop-item-name {\n  color: #e2e8f0;\n}\n.dark .cop-replitPanel .cop-item.active {\n  background: #1e293b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n.dark .cop-replitPanel .cop-item-name {\n  color: #94a3b8;\n}\n.dark .cop-replitPanel .cop-item-name.active {\n  color: #60a5fa;\n}\n.dark .cop-replitPanel .cop-item-count,\n.dark .cop-replitPanel .cop-fav-count {\n  background: #1e293b;\n  color: #64748b;\n}\n.dark .cop-replitPanel .cop-fav-card {\n  background: rgba(30, 41, 59, 0.9);\n  border-color: #3d2f1a;\n}\n.dark .cop-replitPanel .cop-fav-card:hover {\n  border-color: #78350f;\n  background: rgba(41, 29, 10, 0.6);\n}\n.dark .cop-replitPanel .cop-fav-card.active {\n  background: #1e293b;\n}\n.dark .cop-replitPanel .cop-fav-title {\n  color: #e2e8f0;\n}\n\n/* POS category panel variant, matched to the Replit sidebar treatment */\n.cop-shell.cop-replitPanel {\n  background:\n    linear-gradient(\n      180deg,\n      #ffffff 0%,\n      #fbfcff 26%,\n      #f9f7fd 58%,\n      #f7f2fb 100%\n    );\n}\n\n.cop-replitPanel .cop-header {\n  padding: 16px 14px 12px;\n  border-bottom: 1px solid #eceef4;\n  background: transparent;\n}\n\n.cop-replitPanel .cop-list-scroll {\n  padding: 16px 16px 18px;\n}\n\n.cop-replitPanel .cop-list {\n  gap: 8px;\n}\n\n.cop-replitPanel .cop-item {\n  min-height: 48px;\n  padding: 12px;\n  border: 1px solid transparent;\n  border-radius: 16px;\n  background: transparent;\n  color: #64748b;\n}\n\n.cop-replitPanel .cop-item:hover:not(.active) {\n  background: rgba(255, 255, 255, 0.6);\n}\n\n.cop-replitPanel .cop-item:hover:not(.active) .cop-item-name {\n  color: #0f172a;\n}\n\n.cop-replitPanel .cop-item.active {\n  background: #ffffff;\n  border-color: transparent;\n  box-shadow:\n    0 1px 2px 0 rgba(0, 0, 0, 0.05),\n    0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n\n.cop-replitPanel .cop-item.combos {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: #ede9fe;\n  color: #334155;\n}\n\n.cop-replitPanel .cop-item.combos:hover:not(.active) {\n  border-color: #ddd6fe;\n  background: rgba(245, 243, 255, 0.6);\n}\n\n.cop-replitPanel .cop-item-name {\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.cop-replitPanel .cop-item-name.active {\n  color: #0860e6;\n  font-weight: 600;\n}\n\n.cop-replitPanel .cop-item-count,\n.cop-replitPanel .cop-fav-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 26px;\n  height: 24px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.cop-replitPanel .cop-item-count.active {\n  color: #64748b;\n}\n\n.cop-replitPanel .cop-item.combos .cop-item-count {\n  color: #7c3aed;\n}\n\n.cop-replitPanel .cop-fav-card {\n  min-height: 58px;\n  margin-bottom: 0;\n  padding: 12px;\n  border: 1px solid #fef3c7;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: none;\n}\n\n.cop-replitPanel .cop-fav-card:hover {\n  border-color: #fde68a;\n  background: rgba(255, 251, 235, 0.6);\n  box-shadow: none;\n}\n\n.cop-replitPanel .cop-fav-card.active {\n  background: #ffffff;\n  border-color: transparent;\n  box-shadow:\n    0 1px 2px 0 rgba(0, 0, 0, 0.05),\n    0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n\n.cop-replitPanel .cop-fav-title {\n  color: #334155;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.cop-replitPanel .cop-fav-sub {\n  color: #d97706;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.cop-replitPanel .cop-fav-count {\n  color: #d97706;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
